export default __webpack_public_path__ + "static/media/wishlist.bb73c975.svg";